module.exports = __webpack_public_path__ + "static/img/about_h5bg_08_zh1.821329f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_h5bg_08_zh1.png
// module id = ZhA8
// module chunks = 34